// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a5744cf6","455":"44b45b6f"}[chunkId] + ".chunk.js";
};